import { render, staticRenderFns } from "./AgentBaseDlg.vue?vue&type=template&id=1b5e9cc0&scoped=true"
import script from "./AgentBaseDlg.vue?vue&type=script&lang=js"
export * from "./AgentBaseDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5e9cc0",
  null
  
)

export default component.exports